import {animationStore, PlayState} from 'stores/animationStore';
import {useEffect} from 'react';
import {useFrame} from '@react-three/fiber';

const playAction = (action) => {
  if (action) {
    action.play();
    action.timeScale = 1;
  }
};
const stopAction = (action) => {
  if (action)
    action.stop();
};
const pauseAction = (action) => {
  if (action)
    action.timeScale = 0;
};

const objectsEqual = (o1, o2) => Object.keys(o1).length === Object.keys(o2).length
  && Object.keys(o1).every(p => o1[p] === o2[p]);

export const usePlayAnimations = (ref, actions) => {
  const animationClips = animationStore(state => state.clips, objectsEqual);
  // const [animationClips, setAnimationClips] = useState([]);
  const clipStates = animationStore(state => state.clipStates);
  const setClipProgression = animationStore(state => state.setClipProgression);
  // const {actions} = useAnimations(animationClips, ref);

  useEffect(() => {
    clipStates.map(clipState => {
      const action = actions[clipState.clipName];
      switch (clipState.playState) {
        case PlayState.Playing:
          playAction(action);
          break;
        case PlayState.Paused:
        case PlayState.Stopped:
        default:
          pauseAction(action);
          break;
      }
    });
  }, [actions, clipStates]);

  useFrame(() => {
    if (!clipStates) return;

    clipStates.map(clipStates => {
      const action = actions[clipStates.clipName];
      if (action) {
        setClipProgression(clipStates.clipName, action.time / action.getClip().duration);
      }
    });

  });
};
